export class NoApplicationRightsError extends Error {
  constructor() {
    super("User has no application rights");
    this.name = "NoApplicationRightsError";
  }
}
